import { t } from 'i18next';
import { upperFirst } from 'lodash';
import * as yup from 'yup';

import { PhoneType } from 'core/enums';

export const contactSchema = () =>
  yup.object({
    firstName: yup.string().label(t('labelFirstName')).required(),
    lastName: yup.string().label(t('labelLastName')).required(),
    email: yup.string().email().label(t('labelEmail')).required(),
    phone: yup
      .string()
      .label(t('labelOfficePhone'))
      .matches(
        /^$|^\+?[0-9\s\-().]{7,20}$/,
        t('messagePhoneNumber10Digits', { type: upperFirst(PhoneType.OFFICE) })
      )
      .nullable(),
    mobile: yup
      .string()
      .label(t('labelMobilePhone'))
      .matches(
        /^$|^\+?[0-9\s\-().]{7,20}$/,
        t('messagePhoneNumber10Digits', { type: upperFirst(PhoneType.MOBILE) })
      )
      .nullable(),
    contactGrouping: yup.object().label(t('labelContactGrouping')).nullable(),
    billTo: yup.object().label(t('labelDefaultBillTo')).required(),
    shipTo: yup.object().label(t('labelDefaultShipTo')).required(),
    soldTo: yup.object().label(t('labelDefaultSoldTo')).required(),
    sendInvitation: yup.boolean().label(t('labelSendInvitation')).nullable(),
    isDefault: yup.boolean().label(t('labelDefault')).nullable(),
  });
